import { Component, OnInit } from '@angular/core';

import { DesignEditDto } from 'src/app/models/design/designEditDto';
import { AlertService } from 'src/app/services/alert.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {

  currentYear: number;
  selectedDesign: DesignEditDto;

  constructor(
    private alert: AlertService) { }

  ngOnInit() {
    this.currentYear = new Date().getFullYear();

  }

  launchAboutModal() {

  }

}
